import { css } from '@emotion/react'

export const baseCarouselStyles = css`
  position: relative;

  .slick-list,
  .slick-slider,
  .slick-track {
    display: block;
    position: relative;
  }

  .slick-loading {
    .slick-slide,
    .slick-track {
      display: hidden;
    }
  }

  .slick-slider {
    box-sizing: border-box;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
  }

  .slick-list {
    margin: 0;
    padding: 0;
    overflow: hidden;

    &:focus {
      border: none;
    }

    &.dragging {
      cursor: pointer;
    }
  }

  .slick-slider {
    .slick-list,
    .slick-track {
      transform: translate3d(0, 0, 0);
    }
  }

  .slick-track {
    top: 0;
    left: 0;

    &:after,
    &:before {
      table-layout: auto;
      content: '';
    }

    &:after {
      clear: both;
    }
  }

  .slick-slide {
    display: hidden;
    float: left;
    height: 100%;
    min-height: 1px;

    img {
      display: block;
    }

    &.slick-loading img {
      display: hidden;
    }

    &.dragging img {
      pointer-events: none;
    }

    &.slick-active.slick-current {
      z-index: 1;
    }
  }

  [dir='rtl'] .slick-slide {
    float: right;
  }

  .slick-initialized .slick-slide {
    display: block;
  }

  .slick-vertical .slick-slide {
    display: block;
    height: auto;
    border: 1px solid transparent;
  }

  .slick-arrow.slick-hidden {
    display: hidden;
  }
`
